import { useEventListener } from '@vueuse/core';
import { remoteVideoModalOpen } from '@/views/components/modals/modal-types/video-modal/video-modal';
import { ModalTypesEnum } from '@/views/components/modals/enums';

const openModal = () => {
    const videoModal = document.getElementById('video-modal');
    const params = new URLSearchParams(window.location.search);
    const SEARCH_PARAM = 'video-id';

    if (params.has(SEARCH_PARAM) && videoModal) {
        const fakeTriggerElement = document.createElement('div');
        fakeTriggerElement.dataset.type = ModalTypesEnum.VIDEO;
        fakeTriggerElement.dataset.videoSrc = `https://www.youtube.com/embed/${params.get(SEARCH_PARAM)}`;
        fakeTriggerElement.dataset.width = '100%';
        fakeTriggerElement.dataset.height = 'auto';
        fakeTriggerElement.dataset.background = '#000';

        remoteVideoModalOpen(fakeTriggerElement);
    }
};

useEventListener(document, 'DOMContentLoaded', openModal);
